import { render, staticRenderFns } from "./default.vue?vue&type=template&id=1878d006&scoped=true"
import script from "./default.vue?vue&type=script&setup=true&lang=ts"
export * from "./default.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./default.vue?vue&type=style&index=0&id=1878d006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878d006",
  null
  
)

export default component.exports